<template>
  <div
    :class="{ hidden: !isShow }"
    class="rm-select"
  >
    <NuxtLink
      v-if="depth > 0"
      :to="allLots"
      class="rm-select-item pl-5"
      @click="handleClickAllLots($event)"
    >
      Все товары этой категории
    </NuxtLink>
    <a
      v-for="(category, index) in categories"
      :key="index"
      :href="$localePath(`/${city.slug}/catalog/${category.slug}`)"
      :class="{
        'bg-gray-200 !text-blue-500': selectedCategory.id == category.id,
        'mx-5 rounded-[20px] bg-gray-200 my-[14px] border-none !h-auto': depth === 0
      }"
      class="rm-select-item"
      @click="handleClick(category, $event)"
    >
      <div
        :class="{
          'px-4 py-2': depth === 0
        }"
        class="flex flex-row items-center px-5"
      >
        <div
          v-if="depth === 0"
          class="flex flex-none w-14 h-14 mr-4 rounded-full bg-blue-500 p-[14px] text-white justify-center items-center"
        >
          <component
            :is="getCategoryIcon(category.slug)"
            v-if="hasCategoryIcon(category.slug)"
          />
        </div>
        <slot :category="category" />
      </div>
      <div
        v-if="category.hasChildren"
        class="px-5"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.16074 6.49408C7.83531 6.81951 7.83531 7.34715 8.16074 7.67259L10.4882 10L8.16074 12.3274C7.83531 12.6528 7.83531 13.1805 8.16074 13.5059C8.48618 13.8314 9.01382 13.8314 9.33926 13.5059L12.2559 10.5893C12.5814 10.2638 12.5814 9.73618 12.2559 9.41074L9.33926 6.49408C9.01382 6.16864 8.48618 6.16864 8.16074 6.49408Z"
          />
        </svg>
      </div>
    </a>
  </div>
</template>

<script setup>
import isEmpty from 'es-toolkit/compat/isEmpty'
import { useCategorisTreeItem } from '~/components/categories_menu/useCategorisTreeItem.ts'

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  hasChildren: {
    type: Boolean,
    default: false,
  },
  depth: {
    type: Number,
    default: 0,
  },
  selectedCategory: {
    type: Object,
    default: () => {},
  },
})

const emit = defineEmits(['click'])

const searchForm = useSearchForm()
const city = searchForm.city
const selectedCategoryInMenu = useGlobal().selectedCategoryInMenu
const selectCategory = searchForm.selectCategory
const hideCategoriesMenu = useGlobal().hideCategoriesMenu

// Computed
const isShow = computed(() => {
  return isEmpty(props.selectedCategory)
})

const allLots = computed(() => {
  return useLocalePath()(`/${city.value.slug}/catalog/${selectedCategoryInMenu.value?.slug}`)
})

// Methods
function handleClickAllLots (event) {
  // Разрешаем навигацию при Ctrl+Click или Cmd+Click
  if (event.ctrlKey || event.metaKey) {
    return
  }

  // Для обычного клика - предотвращаем навигацию и обрабатываем программно
  event.preventDefault()
  hideCategoriesMenu()
  selectCategory(selectedCategoryInMenu.value)
}

function handleClick (category, event) {
  // Разрешаем навигацию при Ctrl+Click или Cmd+Click
  if (event.ctrlKey || event.metaKey) {
    return // Не предотвращаем событие, позволяем стандартную навигацию
  }

  // Для обычного клика - предотвращаем навигацию и обрабатываем программно
  event.preventDefault()
  emit('click', category)
}

const { getCategoryIcon, hasCategoryIcon } = useCategorisTreeItem()

</script>

<style lang="sass" scoped>
  .rm-select
    @apply w-full
    .rm-select-item
      @apply flex text-gray-900 justify-between items-center border-b h-12 border-gray-300 font-bold text-sm
</style>
